define('shared/lib/RSVP',[
    'kernel/Defer', 
    'shared/lib/console', 
    'shared/util/promise/Result'
], function(Defer, console, Result){
    'use strict';
    Defer.defer = function() {
        return new Defer();
    };
    Defer.onError = function(err){
        if (err instanceof Result) {
            return;
        }
        console.error('Compact Promise detects an error: ', err);
    };
    return Defer;
} ); 

